import React from 'react';
import { buildingBlocks } from '../../data/content';
import { IMAGES } from '../../data/site';
import { SectionCTA } from '../SectionCTA';
export function Author() {
  return <section className="w-full bg-navy-900 px-4 py-16 sm:px-6 sm:py-20" data-id="element-75" data-mp="1wgovf76345ce">
      <div className="mx-auto max-w-5xl" data-id="element-76" data-mp="1wiruegp7t8t9">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-go" data-id="element-77" data-mp="1rpf84d80de3o">
          🦷 Meet your author
        </p>
        <h2 className="mt-3 text-center font-display text-4xl font-bold leading-tight text-white sm:text-5xl" data-id="element-78" data-mp="25fsdq8xfggpu">
          Dr. Karito
        </h2>
        <p className="mt-2 text-center text-[15px] text-white/65" data-id="element-79" data-mp="2ff9h2jp7iiin">
          Turning clinical knowledge into a practical workflow.
        </p>

        <div className="mt-10 grid items-center gap-8 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)]" data-id="element-80" data-mp="2ahrgphp99bm9">
          <img src={IMAGES.author} alt="Portrait of Dr. Karito in her dental clinic" className="mx-auto w-full max-w-xs rounded-3xl object-cover shadow-lift ring-1 ring-white/15 sm:max-w-sm" data-id="element-81" data-mp="l21t9bznf76i" />

          <div className="space-y-4 text-[15px] leading-relaxed text-white/75" data-id="element-82" data-mp="3kfxy6wudu995">
            <p data-id="element-83" data-mp="3kdvbaloj0w8n">
              Dr. Karito created the DVO Clinical Workflow Builder™ after recognizing a challenge
              shared by many dentists: the amount of information available is enormous — but
              information isn’t the same as a workflow.
            </p>
            <p data-id="element-84" data-mp="2yy7eqnzwj7a">
              Complex DVO and rehabilitation cases require dentists to organize multiple variables,
              records, observations and planning considerations. The Workflow Builder was designed
              to help turn those elements into a structured, repeatable process.
            </p>

            <blockquote className="border-l-2 border-go pl-4 font-display text-lg italic leading-snug text-white sm:text-xl" data-id="element-85" data-mp="gyfzpg0i2ele">
              “You don’t always need more information. Sometimes you need a better way to organize
              the information you already have.”
              <footer className="mt-2 text-[11px] font-bold uppercase not-italic tracking-[0.16em] text-go" data-id="element-86" data-mp="3m2b2n7oct30i">
                — Dr. Karito
              </footer>
            </blockquote>

            <ul className="flex flex-wrap gap-2 pt-1" data-id="element-87" data-mp="3v3971r2pfcjm">
              {buildingBlocks.map(block => <li key={block} className="rounded-full bg-white/10 px-3.5 py-1.5 text-[12.5px] font-semibold text-white/85" data-id="element-88" data-mp="3q21xbmh043ab">
                  {block}
                </li>)}
            </ul>
            <p className="text-[13px] font-bold uppercase tracking-[0.1em] text-white/50" data-id="element-89" data-mp="hna4cbkvh6rv">
              Everything organized around one repeatable workflow.
            </p>
          </div>
        </div>

        <SectionCTA transformation="Built by a clinician, for complex cases." label="Get Dr. Karito’s DVO workflow system" subline="$27 one-time · Lifetime access" onDark data-id="element-90" data-mp="rl7tr2egx9m2" />
      </div>
    </section>;
}